import(/* webpackMode: "eager" */ "/vercel/path0/apps/store/src/app/global-error.tsx");
